import React, { ReactElement } from 'react';

import styles from './details-pop-up-content.module.scss';

type Props = {
  leftContent: ReactElement;
  rightContent: ReactElement;
  header: ReactElement;
  onSubmit?: () => void;
  isDisabled?: boolean;
};

const DetailsPopUpContent = ({ leftContent, rightContent, header, onSubmit, isDisabled }: Readonly<Props>): React.JSX.Element => (
  <form
    onSubmit={(event) => {
      event.preventDefault();
      event.stopPropagation();
      if (onSubmit) {
        onSubmit();
      }
    }}
    className={styles.detailsForm}
    data-testid="detailPopupForm"
  >
    <fieldset className={styles.detailsContent} disabled={isDisabled}>
      <div className={styles.leftContent}>{leftContent}</div>
      <div className={styles.rightContent}>
        {header}
        <div className={styles.rightContentContainer}>{rightContent}</div>
      </div>
    </fieldset>
  </form>
);

export default DetailsPopUpContent;
